import { render } from "./SignUpModule.vue?vue&type=template&id=19a6630a&scoped=true"
import script from "./SignUpModule.vue?vue&type=script&lang=js"
export * from "./SignUpModule.vue?vue&type=script&lang=js"

import "./SignUpModule.vue?vue&type=style&index=0&id=19a6630a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a6630a"]])

export default __exports__